import Immutable from 'immutable';
import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'remote-redux-devtools';
import { devUrls, env_production } from './constants';
import { combinedReducers, combinedEpics } from 'core/reducersAndEpics';

let composeEnhancers;
if (env_production) composeEnhancers = compose;
else
  composeEnhancers = composeWithDevTools({
    realtime: true,
    port: 8000,
    suppressConnectErrors: false,
    name: 'WEB',
    hostname: devUrls.reduxDevToolsIP,
  });

const initialState = Immutable.Map();

var epicMiddleware = createEpicMiddleware(combinedEpics);
var middlewares = applyMiddleware(routerMiddleware(browserHistory), epicMiddleware);

export const store = createStore(combinedReducers, initialState, composeEnhancers(middlewares));

const createSelectLocationState = () => {
  let prevRoutingState, prevRoutingStateJS;
  return state => {
    const routingState = state.get('routing');
    if (typeof prevRoutingState === 'undefined' || prevRoutingState !== routingState) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }
    return prevRoutingStateJS;
  };
};

export const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: createSelectLocationState(),
});

if (module.hot) {
  // dev mode
  module.hot.accept('core/reducersAndEpics', () => {
    const combinedEpics = require('core/reducersAndEpics').combinedEpics;
    epicMiddleware.replaceEpic(combinedEpics);
  });
}



// WEBPACK FOOTER //
// src/core/store.js